import { Badge } from "@/shared/components/ui/badge";
import { cn } from "@/shared/lib/utils";

// One amber pill for every beta surface; `sm` shrinks the box, not the type.
export function BetaBadge({
  className,
  size = "default",
}: {
  className?: string;
  size?: "default" | "sm";
}) {
  return (
    <Badge
      variant="secondary"
      className={cn(
        "shrink-0 border-amber-500/25 bg-amber-500/10 text-[10px] font-semibold tracking-wide text-amber-900 uppercase dark:text-amber-100",
        size === "sm" ? "h-4 px-1" : "h-5 px-1.5",
        className,
      )}
    >
      Beta
    </Badge>
  );
}
